import { z } from 'zod';
import { PasswordSchema } from '@aegislab/shared';

export const passwordChangeSchema = z
  .object({
    currentPassword: z.string().min(1, '현재 비밀번호를 입력해주세요'),
    newPassword: z.string().min(1, '새 비밀번호를 입력해주세요').pipe(PasswordSchema),
    confirmPassword: z.string().min(1, '비밀번호 확인을 입력해주세요'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: '비밀번호가 일치하지 않습니다',
    path: ['confirmPassword'],
  })
  .refine((data) => data.currentPassword !== data.newPassword, {
    message: '현재 비밀번호와 다른 비밀번호를 입력해주세요',
    path: ['newPassword'],
  });

export type PasswordChangeData = z.infer<typeof passwordChangeSchema>;

export const passwordChangeDefaults: PasswordChangeData = {
  currentPassword: '',
  newPassword: '',
  confirmPassword: '',
};
